<section class="bg-dark text-white py-24 px-6 md:px-16">
  <h2 class="text-5xl font-bold text-center mb-6 leading-tight max-w-xl mx-auto pt-8">
    Conectamos talento<br>con oportunidades
  </h2>
  <p class="text-lg md:text-xl text-center max-w-3xl mx-auto font-light text-white pt-5">
    En <span class="text-primary font-bold">Codijobs</span> creemos en el poder del talento. Por eso, creamos una plataforma donde personas y empresas se encuentran con un propósito: crecer juntos.
    Con herramientas simples, alertas inteligentes y una comunidad activa, te acompañamos a encontrar tu lugar ideal en el mundo laboral.
  </p>
</section>
<section class="bg-white py-20 px-8 md:px-16 space-y-16 max-w-auto mx-auto">
  <section class="flex items-center justify-center">
    <div class="flex flex-col md:flex-row items-start gap-20 justify-center pt-10">
      <div class="md:w-1/3">
        <h3 class="text-3xl font-bold text-primary mb-4 ">Misión</h3>
        <p class="text-gray-700 leading-relaxed text-justify">
          En Codijobs, nuestra misión es conectar personas talentosas con oportunidades que impulsen su desarrollo profesional y
          personal. Brindamos herramientas tecnológicas accesibles y confiables para facilitar procesos de selección, visibilizar
          perfiles destacados y fomentar relaciones laborales sólidas y duraderas.
        </p>
      </div>
      <div class="md:w-1/3 w-full h-auto md:h-auto bg-black shadow-lg overflow-hidden ">
        <img src="assets/img/vision.jpg" alt="Misión" class="w-full h-full object-cover transition-transform duration-500 hover:scale-105"/>
      </div>
    </div>
  </section>
  <section class="pt-15 flex items-center justify-center">
    <div class="flex flex-col md:flex-row items-start gap-20 justify-center">
      <div class="md:w-1/3 w-full h-auto md:h-auto bg-black shadow-lg overflow-hidden ">
        <img src="assets/img/mision.jpg" alt="Visión" class="w-full h-full object-cover transition-transform duration-500 hover:scale-105"/>
      </div>
      <div class="md:w-1/3">
        <h3 class="text-3xl font-bold text-primary mb-4 ">Visión</h3>
        <p class="text-gray-700 leading-relaxed text-justify">
          Convertirnos en la plataforma de referencia para el talento y el empleo en Latinoamérica, generando un impacto positivo
          en la vida de millones de personas, promoviendo la inclusión, la innovación y el desarrollo sostenible en el mercado laboral.
        </p>
      </div>
    </div>
  </section>
  <section class=" py-12 px-8 pt-15">
    <div class="text-center mb-12">
      <h3 class="text-3xl font-bold text-blue-900">Nuestros Valores</h3>
    </div>
    <div class="flex justify-center gap-20 flex-wrap">
      <div class="w-64 flex flex-col items-center bg-light rounded-lg shadow-lg p-6 transition-shadow duration-300">
        <div class="bg-primary flex items-center justify-center p-5 rounded-md mb-4 text-white">
         <ng-icon name="bootstrapCheck2" size="30"></ng-icon>
        </div>
        <h4 class="text-xl font-semibold text-primary mb-3">Compromiso</h4>
        <p class="text-dark text-center">Dedicación total para acompañarte en tu crecimiento profesional.</p>
      </div>
      <div class="w-64 flex flex-col items-center bg-light rounded-lg shadow-lg p-6 transition-shadow duration-300">
        <div class="bg-primary flex items-center justify-center p-5 rounded-md mb-4 text-white">
          <ng-icon name="bootstrapEye" size="30"></ng-icon>
        </div>
        <h4 class="text-xl font-semibold text-primary mb-3">Transparencia</h4>
        <p class="text-dark text-center">Claridad y confianza en todas nuestras acciones.</p>
      </div>
      <div class="w-64 flex flex-col items-center bg-light rounded-lg shadow-lg p-6 transition-shadow duration-300">
        <div class="bg-primary flex items-center justify-center p-5 rounded-md mb-4 text-white">
          <ng-icon name="bootstrapLightbulb" size="30"></ng-icon>
        </div>
        <h4 class="text-xl font-semibold text-primary mb-3">Innovación</h4>
        <p class="text-dark text-center">Soluciones tecnológicas para conectar talento y oportunidades.</p>
      </div>
    </div>
  </section>
</section>
<section class="bg-blue-50 py-12 px-6 text-center pb-10">
  <p class="text-2xl text-blue-800 font-semibold max-w-2xl mx-auto italic">
    "Más que un portal de empleos, somos un puente entre sueños y oportunidades."
  </p>
  <p class="text-sm text-gray-500 mt-2">— Equipo de Codijobs</p>
</section>
<section class="bg-white py-5 px-6 text-center pb-10"></section>
